import { useState } from 'react';
import IconArrowRight from '../../icons/arrow-right';
import IconDownload from '../../icons/download';
import IconTrash from '../../icons/trash';
import IconSelected from '../../icons/selected';
import { DocumentType, CustomerType } from '../types';
import { PermissionEnum } from '../../../base-types';
import { DocumentControlsTypes } from './types';

import styles from './documents.module.css';

export default function DocumentControls({
  group,
  setDeletePopupVisible,
  onMove,
  onDownload,
  deleteIsVisible,
  customerType,
  moveInProgress,
  documentId,
  activePermissions,
  setDownloadButtonIsActive,
  downloadInProgress,
  downloadButtonIsActive,
  glTransaction,
}: DocumentControlsTypes) {
  const [submenuVisible, setSubmenuVisible] = useState(false);

  return (
    <div className={styles.documentInfoControls}>
      {((!glTransaction &&
        activePermissions?.includes(
          PermissionEnum.TRANSACTIONS_DOCUMENTS_EDIT_ACTION,
        )) ||
        (glTransaction &&
          activePermissions?.includes(
            PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_EDIT_ACTION,
          ))) && (
        <button
          type="button"
          className={styles.documentInfoButton}
          onClick={() => setSubmenuVisible(!submenuVisible)}
          disabled={moveInProgress}
        >
          <IconArrowRight
            className={styles.documentInfoArrowIcon}
            width={10}
            height={10}
          />
          {moveInProgress ? 'Loading...' : 'Move to group'}
        </button>
      )}
      <button
        type="button"
        className={styles.documentInfoButton}
        onClick={() => {
          if (onDownload) {
            onDownload(documentId as string);
          }
          setDownloadButtonIsActive(true);
        }}
        disabled={downloadButtonIsActive && downloadInProgress}
      >
        <IconDownload
          className={styles.documentInfoDownloadIcon}
          width={16}
          height={16}
        />
        {downloadButtonIsActive && downloadInProgress
          ? 'Loading...'
          : 'Download'}
      </button>
      {deleteIsVisible && (
        <button
          type="button"
          className={`${styles.documentInfoButton} ${styles.documentInfoDeleteButton}`}
          onClick={() => setDeletePopupVisible(true)}
        >
          <IconTrash
            className={styles.documentInfoDeleteIcon}
            width={16}
            height={16}
          />
          Delete
        </button>
      )}

      {submenuVisible && (
        <ul className={styles.selectedDocumentsMenu}>
          <li className={styles.selectedDocumentsMenuTitle}>
            Which group to move document to?
          </li>
          {customerType !== CustomerType.CORPORATE && (
            <li>
              <button
                type="button"
                className={`${styles.selectedDocumentsMenuButton} ${
                  group === DocumentType.CLIENT_IDENTIFICATION
                    ? styles.currentGroup
                    : ''
                }`}
                onClick={() => {
                  if (onMove) {
                    onMove({
                      ids: [documentId as string],
                      category: DocumentType.CLIENT_IDENTIFICATION,
                    });
                  }
                  setSubmenuVisible(false);
                }}
              >
                Identification documents
                {group !== DocumentType.CLIENT_IDENTIFICATION && (
                  <div
                    className={styles.selectedDocumentsMenuButtonIconWrapper}
                  >
                    Move
                    <IconArrowRight
                      className={styles.selectedDocumentsMenuButtonIcon}
                      width={10}
                      height={10}
                    />
                  </div>
                )}
                {group === DocumentType.CLIENT_IDENTIFICATION && (
                  <IconSelected />
                )}
              </button>
            </li>
          )}

          <li>
            <button
              type="button"
              className={`${styles.selectedDocumentsMenuButton} ${
                group === DocumentType.CLIENT_TRANSACTION
                  ? styles.currentGroup
                  : ''
              }`}
              onClick={() => {
                if (onMove) {
                  onMove({
                    ids: [documentId as string],
                    category: DocumentType.CLIENT_TRANSACTION,
                  });
                }

                setSubmenuVisible(false);
              }}
            >
              Transaction documents
              {group !== DocumentType.CLIENT_TRANSACTION && (
                <div className={styles.selectedDocumentsMenuButtonIconWrapper}>
                  Move
                  <IconArrowRight
                    className={styles.selectedDocumentsMenuButtonIcon}
                    width={10}
                    height={10}
                  />
                </div>
              )}
              {group === DocumentType.CLIENT_TRANSACTION && <IconSelected />}
            </button>
          </li>
          <li>
            <button
              type="button"
              className={`${styles.selectedDocumentsMenuButton} ${
                group === DocumentType.CLIENT_PSP_CUSTOMER
                  ? styles.currentGroup
                  : ''
              }`}
              onClick={() => {
                if (onMove) {
                  onMove({
                    ids: [documentId as string],
                    category: DocumentType.CLIENT_PSP_CUSTOMER,
                  });
                }

                setSubmenuVisible(false);
              }}
            >
              PSP-Customer documents
              {group !== DocumentType.CLIENT_PSP_CUSTOMER && (
                <div className={styles.selectedDocumentsMenuButtonIconWrapper}>
                  Move
                  <IconArrowRight
                    className={styles.selectedDocumentsMenuButtonIcon}
                    width={10}
                    height={10}
                  />
                </div>
              )}
              {group === DocumentType.CLIENT_PSP_CUSTOMER && <IconSelected />}
            </button>
          </li>
          <li>
            <button
              type="button"
              className={`${styles.selectedDocumentsMenuButton} ${
                group === DocumentType.CLIENT_CDD_CHECK
                  ? styles.currentGroup
                  : ''
              }`}
              onClick={() => {
                if (onMove) {
                  onMove({
                    ids: [documentId as string],
                    category: DocumentType.CLIENT_CDD_CHECK,
                  });
                }

                setSubmenuVisible(false);
              }}
            >
              CDD check documents
              {group !== DocumentType.CLIENT_CDD_CHECK && (
                <div className={styles.selectedDocumentsMenuButtonIconWrapper}>
                  Move
                  <IconArrowRight
                    className={styles.selectedDocumentsMenuButtonIcon}
                    width={10}
                    height={10}
                  />
                </div>
              )}
              {group === DocumentType.CLIENT_CDD_CHECK && <IconSelected />}
            </button>
          </li>
          <li>
            <button
              type="button"
              className={`${styles.selectedDocumentsMenuButton} ${
                group === DocumentType.OTHER ? styles.currentGroup : ''
              }`}
              onClick={() => {
                if (onMove) {
                  onMove({
                    ids: [documentId as string],
                    category: DocumentType.OTHER,
                  });
                }

                setSubmenuVisible(false);
              }}
            >
              Other documents
              {group !== DocumentType.OTHER && (
                <div className={styles.selectedDocumentsMenuButtonIconWrapper}>
                  Move
                  <IconArrowRight
                    className={styles.selectedDocumentsMenuButtonIcon}
                    width={10}
                    height={10}
                  />
                </div>
              )}
              {group === DocumentType.OTHER && <IconSelected />}
            </button>
          </li>
        </ul>
      )}
    </div>
  );
}
